module.exports = __webpack_public_path__ + "static/img/bgimg2-4.e497dcd0.png";